import { render, staticRenderFns } from "./ContestRainbowStat.vue?vue&type=template&id=3267cb5b&"
import script from "./ContestRainbowStat.vue?vue&type=script&lang=js&"
export * from "./ContestRainbowStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports